import { MdDescription, MdImage, MdPermMedia, MdBlock } from 'react-icons/md';
import { IconType } from 'react-icons';

export type ContextMode = 'None' | 'Text only' | 'Image Only' | 'Text + Image';

export const getContextModeIcon = (contextMode: ContextMode): IconType => {
    switch (contextMode) {
        case 'None':
            return MdBlock;
        case 'Text only':
            return MdDescription;
        case 'Image Only':
            return MdImage;
        case 'Text + Image':
            return MdPermMedia;
        default:
            return MdPermMedia;
    }
};

export const getContextModeLabel = (contextMode: ContextMode): string => {
    return contextMode;
};

export const getAllContextModes = (): ContextMode[] => {
    return ['None', 'Text only', 'Image Only', 'Text + Image'];
};